export default __webpack_public_path__ + "static/media/DNo.37-0.9243ff03.jpg";